<template>
    <div id="app" :class="{'grayscale': grayscale}">
    <app-nav :smallScreen='smallScreen'></app-nav>
    <div v-if="loading" class="loading">
      <p><i class="fa fa-spinner fa-spin"></i> Loading...</p>
    </div>
    <div v-if="riskData" v-show="!loading">
        <transition name="route">
          <router-view
            :state="state" 
            :riskData="riskData"
            :timeBlock="timeBlock"
            :grayscale="grayscale" 
            :toggleScale="toggleScale"
            :setLoading="setLoading"
            :smallScreen="smallScreen">
          </router-view>
        </transition>
    </div>
  </div> 
</template>

<script>
import axios from 'axios';
import createState from './helpers/storeHelpers';
import AppNav from './components/app-nav/AppNav';
import setTimePeriod from './helpers/windowResize';

const URL = process.env.DATA_URL;

export default {
  name: 'app',
  components: {
    'app-nav': AppNav,
  },
  data() {
    return {
      riskData: null,
      state: {},
      errors: [],
      grayscale: false,
      loading: true,
      screenWidth: window.innerWidth,
    };
  },
  created() {
    axios.get(URL)
      .then((response) => {
        this.riskData = response.data;
        this.state = this.createState(response.data);
        this.setLoading();
        this.setTimePeriod();
      })
      .catch((e) => {
        this.errors.push(e);
      });
  },
  mounted() {
    window.addEventListener('resize', this.setWindowWidth.bind(this));
  },
  methods: {
    createState,
    setTimePeriod,
    toggleScale() {
      this.grayscale = !this.grayscale;
    },
    setLoading(loadBool) {
      this.loading = loadBool;
    },
    setWindowWidth() {
      this.screenWidth = window.innerWidth;
    },
  },
  computed: {
    currentView() {
      return this.$route.name;
    },
    timeBlock() {
      const start = this.state.timeBlock.start;
      const end = start + this.state.timeBlock.end;
      return this.riskData.slice(start, end);
    },
    smallScreen() {
      return this.screenWidth < 700;
    },
  },
  watch: {
    screenWidth() {
      this.setTimePeriod();
    },
  },
};
</script>

<style lang="less">
  #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #181063;
}
.loading {
  font-size: 26px;
  text-align: center;
}
/* Styling for collapse transitions */
.collapse-enter-active {
  transition: all .3s ease-in;
}

.collapse-leave-active,  {
  transition: all .3s ease-out;
}


.collapse-enter, .collapse-leave-to {
  opacity: 0;
  overflow: hidden;
}

/* Styling for Route transitions */
.route-enter-active {
  transition: all .5s linear;
}

.route-leave-active,  {
  transition: all .1s linear;
}


.route-enter, .route-leave-to {
  opacity: 0;
}

.appH2 {
  margin: 0 0 10px 0;
}

.historical-expand {
  width: 243px;
}

/*
 * App Colors
 */
   .none {
    background-color: #fff;
  }
  .one {
    background-color: #336633 !important;
  }

  .two {
    background-color: #329939 !important;
  }
  .three {
    background-color: #FFD62C !important;
  }

  .four {
   background-color: #F5A619 !important;
  }

  .five {
   background-color: #CC6533 !important;
  }
  .six {
   background-color: #9D202E !important;
  }
  .grayscale {
    .color-block, .legend-color-block {
      border: 1px solid #555;
    }
    .none {
      border: none;
    }
    .one {
      background-color: #e6e7e8 !important;
    }

    .two {
      background-color:  #c2c4c6 !important;
    }
    .three {
      background-color: #9fa1a4 !important;
    }

    .four {
      background-color: #7e8083 !important;
    }

    .five {
      background-color: #5c5d60 !important;
    }
    .six {
      background-color: #333132 !important;
    }
  }

  @media print {
    @page {
      size: landscape;
    }
    .one, .two, .three, .three, .four, .five, .six {
      -webkit-print-color-adjust: exact;
    }

    .subcat-label-block, .map-subcat-row {
      break-inside: avoid;
      -webkit-break-inside: avoid;
    }
  }

  /* Widths for each year column in map views */
  .one-q {
    .map-indicator-block {
      width: 25px;
    }
  }

  .two-q, .one-q {
    flex: 0 0 50px;
  }

  .three-q {
    flex: 0 0 75px;
  }
  
  .four-q {
    flex: 0 0 100px;
  }

  .left-column {
    flex: 0 0 35%;
    @media (max-width: 800px) {
      flex: 0 0 34%;
    }
  }

  .right-column {
    flex-grow: 2;
  }

  .cat-block-margin {
    margin: 0  0;
  }
</style>



// WEBPACK FOOTER //
// App.vue?0faeff0d